/**
 * ABILITY_SCHOOL_COLORS — fallback projectile/aura color per ability school, used
 * when a TOML `projectileColor`/`auraColor` isn't set (the spell's OWN color).
 *
 * Distinct from the damage-NUMBER palette in `combat-feedback.config` (damageTypeTints) —
 * that colors floating combat text; this colors the projectile/aura. Don't merge them.
 */
export const ABILITY_SCHOOL_COLORS: Record<string, number> = {
  physical: 0xcccccc,
  fire: 0xff4500,
  frost: 0x66ccff,
  arcane: 0xcc66ff,
  shadow: 0x9933cc,
  holy: 0xffdd44,
  nature: 0x44cc44,
  chaos: 0xff0066,
  healing: 0x44ff88,
};
